import {CrudEntityTypes} from '@/classes/clientOnly/permissionTreeResources/enums/CrudEntityTypes';
import {mapRecordToItems} from '@/helpers/mapRecordToItems.helper';

export enum LogEntryTypes {
    COMMON = 'common',
    COURSE = 'course',
    MESSENGER_MAIL = 'messenger_mail',
    MESSENGER_WHATS_APP = 'messenger_whats_app',
    PHONE = 'phone',
    PLACETEL_CALL = 'placetel_call',
    QUALITY_MANAGEMENT_TEACHER = 'quality_management_teacher',
    RETURNING_DELAYED = 'returning_delayed',
    RETURNING_DONE = 'returning_done',
    RETURN_LABEL = 'return_label',
    TERMINATION = 'termination',
    VAPI_CALL = 'vapi_call',
    EARLY_WARNING = 'early_warning',
}

export namespace LogEntryTypes {
    type Data = {text: string};
    
    export const Record: Record<LogEntryTypes, Data> = {
        [LogEntryTypes.COMMON]: {text: 'Allgemein'},
        [LogEntryTypes.COURSE]: {text: 'Kurse'},
        [LogEntryTypes.MESSENGER_MAIL]: {text: 'Messenger Mail'},
        [LogEntryTypes.MESSENGER_WHATS_APP]: {text: 'Messenger WhatsApp'},
        [LogEntryTypes.PHONE]: {text: 'Telefonate'},
        [LogEntryTypes.PLACETEL_CALL]: {text: 'Anruf über Placetel'},
        [LogEntryTypes.QUALITY_MANAGEMENT_TEACHER]: {text: 'Qualitätsmanagement Lehrer'},
        [LogEntryTypes.RETURNING_DELAYED]: {text: 'Rückgaben verzögert'},
        [LogEntryTypes.RETURNING_DONE]: {text: 'Rückgaben erledigt'},
        [LogEntryTypes.RETURN_LABEL]: {text: 'Rücksendeetiketten'},
        [LogEntryTypes.TERMINATION]: { text: 'Kündigungen' },
        [LogEntryTypes.VAPI_CALL]: {text: 'Anruf über VAPI'},
        [LogEntryTypes.EARLY_WARNING]: {text: 'Frühwarnung'},
    }

    export const Items = mapRecordToItems(Record);
}

export enum LogEntryAuthorTypes {
    EMPLOYEE = 'Employee',
    INSTITUTION = 'Institution',
    SYSTEM = 'System',
    MESSENGER_ACCOUNT = 'MessengerAccount',
    SALES_PARTNER = 'SalesPartner',
}

export namespace LogEntryAuthorTypes {
    type Data = {text: string};
    export const Record: Record<LogEntryAuthorTypes, Data> = {
        [LogEntryAuthorTypes.EMPLOYEE]: {text: 'Mitarbeiter:in'},
        [LogEntryAuthorTypes.INSTITUTION]: {text: 'Standort'},
        [LogEntryAuthorTypes.SYSTEM]: {text: 'System'},
        [LogEntryAuthorTypes.MESSENGER_ACCOUNT]: {text: 'Messenger Account'},
        [LogEntryAuthorTypes.SALES_PARTNER]: {text: 'Vertriebspartner'},
    }
    export const Items = mapRecordToItems(Record);
}

export enum LogEntryObjectTypes {
    EMPLOYEE = 'Employee',
    INSTITUTION = 'Institution',
    STUDENT = 'Student',
    PARENT = 'Parent',
    RESPONSIBLE = 'Responsible',
}

export namespace LogEntryObjectTypes {
    export function fromCrudEntityTypes(type: CrudEntityTypes.EMPLOYEE | CrudEntityTypes.INSTITUTION | CrudEntityTypes.PARENT | CrudEntityTypes.STUDENT | CrudEntityTypes.RESPONSIBLE): LogEntryObjectTypes {
        switch (type) {
            case CrudEntityTypes.EMPLOYEE:
                return LogEntryObjectTypes.EMPLOYEE;
            case CrudEntityTypes.INSTITUTION:
                return LogEntryObjectTypes.INSTITUTION;
            case CrudEntityTypes.PARENT:
                return LogEntryObjectTypes.PARENT;
            case CrudEntityTypes.STUDENT:
                return LogEntryObjectTypes.STUDENT;
            case CrudEntityTypes.RESPONSIBLE:
                return LogEntryObjectTypes.RESPONSIBLE;
        }
    }
}

